// Single source of truth for the interface languages.
//
// Locale files are GENERATED from English by scripts/translate_locales.py, so
// adding a language should not mean editing i18n.js, the header dropdown and
// the account page separately — that is how `es` ended up 71 keys behind and
// how a dead "Hindi" entry silently served French.
//
// To add one:
//   1. OPENAI_API_KEY=... python3 scripts/translate_locales.py --add sw
//   2. add an entry below
// Nothing else. The dropdowns and i18n read from here.

import translationEN from './en/translation.json';
import translationFR from './fr/translation.json';
import translationES from './es/translation.json';
import translationPT from './pt/translation.json';
import translationVI from './vi/translation.json';
import translationHI from './hi/translation.json';
import translationAR from './ar/translation.json';
import translationUR from './ur/translation.json';
import publicLandingES from './es/publicLanding';

// `dir` drives the document direction (applied to <html> in i18n.js).
export const LANGUAGES = [
  { code: 'en', label: 'English',  flag: '🇬🇧', flagImage: '/flags/gb.svg', dir: 'ltr', resource: translationEN },
  { code: 'fr', label: 'Français', flag: '🇫🇷', flagImage: '/flags/fr.svg', dir: 'ltr', resource: translationFR },
  {
    code: 'es',
    label: 'Español',
    flag: '🇪🇸',
    flagImage: '/flags/es.svg',
    dir: 'ltr',
    // Landing-page copy lives in its own file; merge per namespace so it
    // overrides individual strings instead of replacing whole sections.
    resource: {
      ...translationES,
      ...publicLandingES,
      public: { ...(translationES.public || {}), ...(publicLandingES.public || {}) },
      landing: { ...(translationES.landing || {}), ...(publicLandingES.landing || {}) },
    },
  },
  { code: 'pt', label: 'Português', flag: '🇵🇹', flagImage: '/flags/pt.svg', dir: 'ltr', resource: translationPT },
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳', flagImage: '/flags/vn.svg', dir: 'ltr', resource: translationVI },
  { code: 'hi', label: 'हिन्दी',     flag: '🇮🇳', flagImage: '/flags/in.svg', dir: 'ltr', resource: translationHI },
  // RTL: <html dir> is switched automatically; see the [dir="rtl"] block in styles.css.
  { code: 'ar', label: 'العربية',    flag: '🇸🇦', flagImage: '/flags/sa.svg', dir: 'rtl', resource: translationAR },
  { code: 'ur', label: 'اردو',       flag: '🇵🇰', flagImage: '/flags/pk.svg', dir: 'rtl', resource: translationUR },
];

export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);

export const RESOURCES = LANGUAGES.reduce((acc, l) => {
  acc[l.code] = { translation: l.resource };
  return acc;
}, {});

export const directionFor = (code) =>
  LANGUAGES.find((l) => l.code === code)?.dir || 'ltr';
